import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

import { faDashboard } from "@vintecc/pro-light-svg-icons/faDashboard";

const searchSchema = z.object({
  folderId: z.number().optional(),
});

export const Route = createFileRoute("/dashboards/")({
  loader: async () => {
    await ensureRouteTranslationModuleLoaded("dashboards");
    const { dashboardQueries } = await import("@/modules/dashboards/services/queries");
    return queryClient.ensureQueryData(dashboardQueries.getDashboards(false));
  },
  staticData: {
    title: "apps.dashboards",
    icon: faDashboard,
  },
  validateSearch: searchSchema,
});
